<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="close"></button>
      <h2 class="layerTitle">{{ locale.category_setting }}</h2>
      <div>
        <div class="mb15">
          <div class="innerTitle setLabel">{{ locale.item_limit_per_category }}</div>
          <span class="checkbox">
            <input type="checkbox" id="use_limit_item_count" v-model="active" />
            <label for="use_limit_item_count">{{ locale.activate }}</label>
          </span>
        </div>
        <div v-if="active">
          <div class="mb15">
            <div class="innerTitle setLabel">{{ locale.item_limit_count }}</div>
            <input type="text" class="input" v-model="itemCount" @keyup="setItemCount">
            <p v-if="!isValid.hasItemCount" class="colorRed">{{ locale.alert_item_limit_count }}</p>
          </div>
          <div class="mb15">
            <div class="innerTitle setLabel">{{ locale.guest_basis }}</div>
            <span class="checkbox">
              <input type="radio" name="count_by_guest" id="count_by_guest_false" :value="false" v-model="countByGuest" />
              <label for="count_by_guest_false">{{ locale.not_applied }}</label>
            </span>
            <span class="checkbox">
              <input type="radio" name="count_by_guest" id="count_by_guest_true" :value="true" v-model="countByGuest" />
              <label for="count_by_guest_true">{{ locale.per_guest }}</label>
            </span>
          </div>

          <!-- 인원수 제외그룹 -->
          <div v-if="countByGuest && guestTypeItems?.length > 0" class="mb15">
            <div class="innerTitle setLabel">{{ locale.exclude_guest_group }}</div>
            <ul>
              <li v-for="guestType in guestTypeItems"
                :key="guestType.groupId">
                <div class="checkbox">
                  <input type="checkbox" :id="`guest_group_${guestType.groupId}`" :value="guestType.groupId" v-model="excludeGuestGroupIds">
                  <label :for="`guest_group_${guestType.groupId}`">{{ guestType.groupName[defaultLang] }}</label>
                </div>
              </li>
            </ul>
          </div>
          <!-- //인원수 제외그룹 -->

          <div class="mb15">
            <div class="innerTitle setLabel">{{ locale.order_basis }}</div>
            <span class="checkbox">
              <input type="radio" name="count_by_order" id="count_by_order_false" :value="false" v-model="countByOrder" />
              <label for="count_by_order_false">{{ locale.per_order }}</label>
            </span>
            <span class="checkbox">
              <input type="radio" name="count_by_order" id="count_by_order_true" :value="true" v-model="countByOrder" />
              <label for="count_by_order_true">{{ locale.total_orders }}</label>
            </span>
          </div>
        </div>
      </div>
      <div class="btns">
        <button type="button" class="btn btnWhite" @click="close">{{ locale.cancel }}</button>
        <button type="button" class="btn btnPrimary" :disabled="!isValid.result" @click="save">{{ locale.save }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'

export default {
  name: 'ShopCategorySetting',
  props: [
    'locale',
    'pageId',
    'catCode',
    'categoryId',
    'defaultLang'
  ],
  computed: {
    isValid () {
      const isActive = this.active
      const hasItemCount = this.itemCount >= 1
      return {
        isActive: isActive,
        hasItemCount: hasItemCount,
        result: isActive ? hasItemCount : true
      }
    },
    shopProperty () {
      return this.$store.getters['shop/getShopProperty'](this.pageId)
    }
  },
  created () {
    this.getShopCategorySettings()
    this.getGuestTypeItems()
  },
  watch: {
    active (isActive) {
      if (!isActive) {
        this.itemCount = 0
        this.countByGuest = false
        this.countByOrder = false
      }
    }
  },
  data () {
    return {
      active: false,
      itemCount: 0,
      countByGuest: false,
      countByOrder: false,
      excludeGuestGroupIds: [],
      guestTypeItems: []
    }
  },
  methods: {
    async getGuestTypeItems () {
      const guestTypeItems = await this.$store.dispatch('shop/getGuestTypeItems', this.catCode)
      const items = guestTypeItems?.message
      this.guestTypeItems = items || []
    },
    async getShopCategorySettings () {
      const data = {
        pageId: this.pageId,
        categoryId: this.categoryId
      }
      const res = await this.$store.dispatch('shop/getShopCategorySettings', data)
      const limitItemCount = res?.message?.limitItemCount
      if (limitItemCount) {
        this.active = limitItemCount.active
        this.itemCount = limitItemCount.itemCount
        this.countByGuest = limitItemCount.countByGuest
        this.countByOrder = limitItemCount.countByOrder
        this.excludeGuestGroupIds = limitItemCount.excludeGuestGroupIds || []
      }
    },
    setItemCount () {
      const val = this.itemCount
      const value = regExp.naturalNumberOnly(val)
      this.itemCount = parseInt(value) || ''
    },
    close () {
      this.$emit('close')
    },
    async save () {
      const res = await this.$store.dispatch('shop/putShopCategorySettings', {
        pageId: this.pageId,
        categoryId: this.categoryId,
        limitItemCount: {
          active: this.active,
          itemCount: this.itemCount,
          countByGuest: this.countByGuest,
          countByOrder: this.countByOrder,
          excludeGuestGroupIds: this.excludeGuestGroupIds
        }
      })
      if (res) {
        alert(this.locale.complete_save)
        this.close()
      } else {

      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer {
  .inner {
    max-width: 400px;
  }
}
</style>